import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';

import { RdsNavTreeComponent } from './nav-tree.component';

@NgModule({
  imports: [CommonModule, MatIconModule, MatTreeModule, RouterModule],
  declarations: [RdsNavTreeComponent],
  exports: [RdsNavTreeComponent],
})
export class RdsNavTreeModule {}

export * from './flat-nav-tree-item.model';
export * from './nav-tree-flattener.model';
export * from './nav-tree-item.model';
export * from './nav-tree.component';
